const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

const handle = async (res) => {
  const text = await res.text();
  const data = text ? JSON.parse(text) : {};
  if (!res.ok) throw new Error(data?.message || "Request failed");
  return data;
};

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
});

export const listAiSessions = async (token, params = {}) => {
  const qs = new URLSearchParams();
  if (params.status) qs.set("status", params.status);
  if (params.handoff) qs.set("handoff", params.handoff);
  if (params.q) qs.set("q", params.q);
  if (params.page) qs.set("page", params.page);
  if (params.limit) qs.set("limit", params.limit);
  const res = await fetch(`${API_BASE}/api/admin/ai/sessions${qs.toString() ? `?${qs}` : ""}`, {
    headers: { Authorization: `Bearer ${token}` },
    credentials: "include",
  });
  return handle(res);
};

export const getAiSession = async (token, sessionUuid) => {
  const res = await fetch(`${API_BASE}/api/admin/ai/sessions/${encodeURIComponent(sessionUuid)}`, {
    headers: { Authorization: `Bearer ${token}` },
    credentials: "include",
  });
  return handle(res);
};

export const assignAiHandoff = async (token, sessionUuid, body = {}) => {
  const res = await fetch(`${API_BASE}/api/admin/ai/sessions/${encodeURIComponent(sessionUuid)}/assign`, {
    method: "PATCH",
    headers: authHeaders(token),
    credentials: "include",
    body: JSON.stringify(body),
  });
  return handle(res);
};

export const resolveAiHandoff = async (token, sessionUuid, body = {}) => {
  const res = await fetch(`${API_BASE}/api/admin/ai/sessions/${encodeURIComponent(sessionUuid)}/resolve`, {
    method: "PATCH",
    headers: authHeaders(token),
    credentials: "include",
    body: JSON.stringify(body),
  });
  return handle(res);
};
